import React from "react";

const PinGlyph = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path d="M8 1.7a4.45 4.45 0 0 0-4.45 4.45c0 3.3 4.45 8.15 4.45 8.15s4.45-4.85 4.45-8.15A4.45 4.45 0 0 0 8 1.7Zm0 6.05a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z" />
  </svg>
);

const OffGlyph = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path d="M10 3.5a4.9 4.9 0 0 0-4.9 4.9c0 3.6 4.9 8.6 4.9 8.6s4.9-5 4.9-8.6A4.9 4.9 0 0 0 10 3.5Z" />
    <path d="m3.5 3.5 13 13" />
  </svg>
);

const LocationStatus = ({ locating, usingFallback, denied, label, onLocate }) => {
  if (locating) {
    return (
      <p className="home-status is-locating" role="status">
        <span className="home-status-spinner" aria-hidden="true" />
        Finding your location…
      </p>
    );
  }

  if (usingFallback) {
    return (
      <div className="home-status is-fallback" role="status">
        <span className="home-status-icon" aria-hidden="true">
          <OffGlyph />
        </span>
        <span className="home-status-text">
          <b>{denied ? "Location is off" : "We couldn't find you yet"}</b>
          <span>Showing suppliers near {label || "Accra, Ghana"}</span>
        </span>
        <button type="button" className="home-status-action" onClick={onLocate}>
          Use my location
        </button>
      </div>
    );
  }

  if (!label) return null;

  return (
    <p className="home-status">
      <span className="home-status-pin" aria-hidden="true">
        <PinGlyph />
      </span>
      <span className="home-status-label">{label}</span>
    </p>
  );
};

export default React.memo(LocationStatus);
